const LOAD_DETAIL_ORGANIZER           = 'LOAD_DETAIL_ORGANIZER'
const LOAD_DETAIL_ORGANIZER_SUCCESS   = 'LOAD_DETAIL_ORGANIZER_SUCCESS'
const LOAD_DETAIL_ORGANIZER_FAILED    = 'LOAD_DETAIL_ORGANIZER_FAILED'
const UNMOUNT_DETAIL_ORGANIZER        = 'UNMOUNT_DETAIL_ORGANIZER'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const organizerDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_ORGANIZER:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_ORGANIZER_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_ORGANIZER_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_ORGANIZER:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default organizerDetailReducer;